<script setup lang="ts">

import type { IModalProps } from '@library/Components';
const { modal } = defineProps<IModalProps>();

const openLink = ( url: string ) => 
{
    window.open( url, '_blank' );
    modal.close();
}

</script>

<template>

    <div class="bg-white rounded-2xl p-8 max-w-2xl font-semibold">
        <IconButton name="cross" 
                    class="absolute right-3 top-3 text-black"
                    @click="() => modal.close()" />
        <img src="@/assets/images/carbucks.png" class="h-12 -ml-2 mb-4"/>
        <h1 class="text-3xl font-semibold">
            Let's get you onto Carbucks, where do you want to go?
        </h1>

        <div class="flex items-center gap-6 mt-6">

            <Button variant="flat"
                    color="var(--color-primary-600)"
                    size="large"
                    class="get-the-app-shadow !h-16 text-white !rounded-[8px] tracking-wider"
                    @click="openLink( 'https://apps.apple.com/au/app/carbucks/id6462980416' )">
                    <Icon name="apple" class="text-2xl mr-1.5"></Icon>
                    <span class="text-sm">Apple App Store</span>
            </Button>

            <Button variant="flat"
                    color="var(--color-primary-600)"
                    size="large"
                    class="get-the-app-shadow !h-16 text-white !rounded-[8px] tracking-wider"
                    @click="openLink( 'https://play.google.com/store/apps/details?id=com.connectedvehicles.carbucks' )">
                    <Icon name="google-play" class="text-lg mr-3"></Icon>
                    <span class="text-sm">Google Play</span>
            </Button>

        </div>
    </div>

</template>